var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDelete = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M7.89 17.947c.06.504.558.912 1.11.912h6c.552 0 1.05-.408 1.11-.912l.89-7.354H7zM9 7.837 9.75 6h4.5L15 7.837h2c1 0 1 1.837 1 1.837H6s0-1.837 1-1.837zm1 0h4l-.5-.918h-3z"
})));
export { SvgDelete as ReactComponent };
export default __webpack_public_path__ + "static/media/delete.b7796596.svg";